import { updateWhenLocaleChanges } from '@lit/localize';
import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { setupRouter } from '../router';
import { AuthStore } from '../stores/AuthStore';
import { appStyles } from './app/App.styles';
import { renderAppTemplate } from './app/App.template';

@customElement('app-root')
export class App extends LitElement {
  static styles = appStyles;

  connectedCallback() {
    super.connectedCallback();
    updateWhenLocaleChanges(this);
  }

  firstUpdated() {
    const outlet = this.renderRoot.querySelector('#outlet');
    if (outlet) {
      setupRouter(outlet, () => AuthStore.instance.isAuthenticated());
    } else {
      console.error('No outlet found');
    }
  }

  render() {
    return renderAppTemplate();
  }
}
